





















































































































































































import {
  Vue, Component, Prop, Emit,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbPagination } from '@/shared/pagination/pagination.component.vue';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import MainButton from '@/shared/buttons/main-button.component.vue';
import splitContent from '@/shared/directive/split-content';
import DateHandler from '@/shared/utils/date-format';
import BindInstance from '@/domain/contract/entity/bind-instance.entity';
import Contract from '@/domain/contract/entity/contract.entity';
import InstanceService from '@/domain/contract/service/instance.service';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import EditInstanceRequest from '@/domain/contract/request/edit-instance-request.entity';
import ContractModal from '@/views/instances/contract-modal.component.vue/contract-modal.component.vue';
import InstanceStatusFactory from '@/views/instances/instances-datatable/InstanceStatusFactory';
import instanceUtils from '@/views/instances/instances-datatable/instance-utils';
import InstanceFilter from '@/domain/contract/entity/instance-filter.entity';
import UnboundInstance from '@/domain/contract/entity/unbound-instance.entity';
import ContractService from '@/domain/contract/service/contract.service';
import Response from '@/domain/response.entity';
import Header from './header.json';
import ContractInfoModalNewInstance from '../contract-into-modal-new-instance.component.vue';
import ContractInstance from '../../../../domain/contract/entity/contract-instance.entity';
import Pagination from '../../../../domain/pagination.entity';

@Component({
  components: {
    MainButton,
    VbPagination,
    ModalWarning,
    VbTooltipSlot,
    ContractInfoModalNewInstance,
    ContractModal,
  },
  filters: {
    splitContent,
    formatDate(value: string) {
      return DateHandler.timestampToLocal(value);
    },
  },
})

export default class Instances extends Vue {
  @Prop({
    required: true,
  })
  instances!: Array<ContractInstance>;

  @Prop({ required: true }) contract!: Contract;

  @Prop({
    required: false,
    default: 'auto',
  })
  tableHeight!: string;

  @Prop({
    required: false,
    default: true,
  })
  border!: boolean;

  @Prop({
    required: true,
  })
  businessUnitId!: string;

  @Prop({
    required: true,
  })
  contractId!: string;

  @Prop() isAdministratorOrSupervisorOrGp!: boolean;

  newInstanceModal: boolean = false;

  newInstanceModalKey: number = 0;

  persistBindInstance: BindInstance = BindInstance.of({});

  header = Header;

  warningModalValue: boolean = false;

  warningMessage: string = '';

  deleteInstanceId: string = '';

  instanciasAtivas: number = 0;

  instanciasInativas: number = 0;

  search = '';

  onlyActive: boolean = false;

  instanceStatusFactory!: InstanceStatusFactory;

  showContractModal = false;

  modalKey = 0;

  selectedInstance: UnboundInstance = UnboundInstance.of({});

  unboundInstances: UnboundInstance[] = [];

  filter: InstanceFilter = new InstanceFilter(
    {
      status: this.getInitialStatusFilter(),
    },
  );

  loading: boolean = true;

  reprocessLoading: boolean = false;

  reprocessModalValue: boolean = false;

  readonly reprocessWarningMessage: string = 'O reprocessamento sincroniza com todas as plataformas integradas via webhook. '
    + 'Deseja realmente <strong>reprocessar</strong> as instâncias? '
    + 'Ao clicar em Sim, a operação será executada imediatamente.';

  pagination: Pagination = new Pagination({
    page: 1,
    itemsPerPage: 5,
    total: 10,
    pageCount: 1,
  });

  get totalFiltered() {
    return this.filteredInstances.length;
  }

  get filteredInstances() {
    let filtered = this.instances;
    if (this.onlyActive) {
      filtered = filtered.filter((item) => item.active === true);
    }
    if (this.search) {
      const searchLower = this.search.toLowerCase();
      filtered = filtered.filter(
        (item) => item.code?.toLowerCase().includes(searchLower)
        || item.description?.toLowerCase().includes(searchLower)
        || item.status?.toLowerCase().includes(searchLower)
        || String(item.active).toLowerCase().includes(searchLower),
      );
    }
    return filtered;
  }

  onSearchInput(value: string) {
    this.search = value;
    this.pagination.page = 1;
    this.updateTable();
  }

  onOnlyActiveChange(value: boolean) {
    this.onlyActive = value;
    this.pagination.page = 1;
    this.updateTable();
  }

  transferInstances(contractId: string) {
    ContractService.bindUnboundInstances(this.businessUnitId, contractId, [this.selectedInstance])
      .then((response: any) => {
        VbSnackbarService.showSuccess('Instância transferida com sucesso');
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        this.selectedInstance = UnboundInstance.of({});
        this.showContractModal = false;
        this.emitUpdateContractEvent();
      });
  }

  getInitialStatusFilter(): string {
    this.instanceStatusFactory = new InstanceStatusFactory();
    const withConsumption = instanceUtils.getInstanceUrlQueryParams(
      this.$route.query.withConsumption,
    );
    const status = 'ACTIVE';
    return this.instanceStatusFactory.getInstanceStatus(
      status,
      withConsumption,
    );
  }

  openModal(instance: UnboundInstance): void {
    this.selectedInstance = instance;
    this.modalKey += 1;
    this.showContractModal = true;
  }

  updateModalValue(value: boolean): void {
    this.newInstanceModalKey = value ? this.newInstanceModalKey + 1 : this.newInstanceModalKey;
    this.newInstanceModal = value;
  }

  updateWarningModalState(value: boolean): void {
    this.warningModalValue = value;
  }

  updateTable() {
    const total = this.filteredInstances.length;

    this.pagination.total = total;

    this.pagination.pageCount = Math.ceil(
      total / this.pagination.itemsPerPage,
    ) || 1;

    this.instanciasAtivas = this.filteredInstances.filter((it) => it.active).length;
    this.instanciasInativas = total - this.instanciasAtivas;

    if (this.pagination.page > this.pagination.pageCount) {
      this.pagination.page = 1;
    }
  }

  concludedAt(value: string) {
    return value ? DateHandler.timestampToLocal(value) : '-';
  }

  @Emit('updateContract')
  emitUpdateContractEvent(): void {}

  setDeleteInstanceId(instanceId: string): void {
    this.deleteInstanceId = instanceId;
  }

  setDeleteWarningMessage(): void {
    this.warningMessage = 'Deseja realmente <strong style="color: orange">remover</strong> a instância? '
      + 'Ao clicar no botão Sim, as alterações serão imediatamente realizadas.';
  }

  showWarningModal(instanceId: string): void {
    this.updateWarningModalState(true);
  }

  clickEditInstance(instance: ContractInstance): void {
    this.persistBindInstance = BindInstance.of(instance);
    this.updateModalValue(true);
  }

  editInstance(instance: BindInstance): void {
    InstanceService
      .editInstance(
        this.businessUnitId, this.contractId, instance.id, EditInstanceRequest.of(instance),
      )
      .then((response) => {
        VbSnackbarService.showSuccess('Instância alterada com sucesso');
        this.emitUpdateContractEvent();
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        this.updateModalValue(false);
      });
  }

  deleteInstance(): void {
    InstanceService.deleteInstance(this.businessUnitId, this.contractId, this.deleteInstanceId)
      .then((response) => {
        this.emitUpdateContractEvent();
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        this.deleteInstanceId = '';
        this.warningMessage = '';
        this.updateWarningModalState(false);
        VbSnackbarService.showSuccess('Instância removida com sucesso');
      });
  }

  openReprocessModal(): void {
    this.reprocessModalValue = true;
  }

  reprocessInstances(): void {
    this.reprocessModalValue = false;
    if (this.reprocessLoading) return;
    this.reprocessLoading = true;
    InstanceService.reprocessInstances(this.businessUnitId, this.contractId)
      .then(() => {
        VbSnackbarService.showSuccess('Instâncias reprocessadas com sucesso');
        this.emitUpdateContractEvent();
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        this.reprocessLoading = false;
      });
  }

  createNewInstance(): void {
    this.updateModalValue(true);
    this.persistBindInstance = BindInstance.of({});
  }

  bindExistingInstance(instance: BindInstance): void {
    this.persistBindInstance = instance;
    this.updateModalValue(true);
  }

  bindInstance(instance: BindInstance): void {
    if (!this.contract.isActive) {
      VbSnackbarService.showError('Só é possível víncular instâncias em contratos com status Ativo');
      return;
    }
    InstanceService.bindInstance(this.businessUnitId, this.contract.id, instance)
      .then(() => {
        VbSnackbarService.showSuccess('Instância vinculada com sucesso');
        this.updateModalValue(false);
        this.emitUpdateContractEvent();
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        this.persistBindInstance = BindInstance.of({});
      });
  }

  private created(): void {
    this.updateTable();
  }
}
